<template>
    <button type="button" class="relative pr-5 hover:opacity-100 transition ease-in-out duration-200" :class="{'opacity-50': !active}">
        <span class="text-white">{{ name }}</span>
        <span class="absolute -top-2 right-0 w-[15px]">
            <span class="text-xs" :class="active ? 'text-pink' : 'text-white'">{{ number }}</span>
        </span>
    </button>
</template>

<script>
export default {
    name: "AtomTab",
    props: {
        name: {
            type: String,
            default: ""
        },
        number: {
            type: Number,
            default: 0
        },
        active: {
            type: Boolean,
            default: false
        }
    },
}
</script>

<style scoped></style>
